// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @keyframes zIndexIn {
  from {
    z-index: 0;
  	opacity: 0;
  	pointer-events: none;
  }

  to {
    z-index: 1;
    opacity: 1;
    pointer-events: auto;
  }
}

.zIndexIn .zIndex-animation {
  animation-name: zIndexIn;
  animation-direction: reverse;
}

.zIndexIn.animated .zIndex-animation {
  animation-name: zIndexIn;
  animation-direction: normal;
} */


.zIndexIn .zIndex-animation {
  z-index: 0;
  opacity: 0;
  pointer-events: none;
}

.zIndexIn.animated .zIndex-animation {
  z-index: 1;
  opacity: 1;
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/zIndex_entrances/zIndexIn.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;AAGH;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* @keyframes zIndexIn {\n  from {\n    z-index: 0;\n  \topacity: 0;\n  \tpointer-events: none;\n  }\n\n  to {\n    z-index: 1;\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n.zIndexIn .zIndex-animation {\n  animation-name: zIndexIn;\n  animation-direction: reverse;\n}\n\n.zIndexIn.animated .zIndex-animation {\n  animation-name: zIndexIn;\n  animation-direction: normal;\n} */\n\n\n.zIndexIn .zIndex-animation {\n  z-index: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.zIndexIn.animated .zIndex-animation {\n  z-index: 1;\n  opacity: 1;\n  pointer-events: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
